import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkIsEligibleRequest = {};
var _bulkIsEligibleResponse = { results: '_isEligibleResult' };
var _cancelFeatureByNameRequest = {};
var _cancelFeatureByNameResponse = {};
var _createFeatureRequest = {};
var _createFeatureResponse = {};
var _feature = {
    createdAt: 'google.protobuf.Timestamp',
    updatedAt: 'google.protobuf.Timestamp',
    quotaInfo: '_quotaInfo',
};
var _getFeatureRequest = {};
var _getFeatureResponse = { features: '_feature' };
var _getFeaturesBulkRequest = {};
var _getFeaturesBulkResponse = { features: '_feature' };
var _isEligibleRequest = {};
var _isEligibleResponse = { quotaViolation: '_quotaViolation' };
var _isEligibleResult = { quotaViolation: '_quotaViolation' };
var _listFeaturesRequest = {};
var _listFeaturesResponse = { features: '_feature' };
var _quotaInfo = { breakdown: '_quotaInfoEntry' };
var _quotaInfoEntry = { resetDate: 'google.protobuf.Timestamp' };
var _quotaViolation = { breakdown: '_quotaInfoEntry' };
var _reportQuotaUsageRequest = {
    usageDateInUtc: 'google.protobuf.Timestamp',
};
var _reportQuotaUsageResponse = {};
var _updateBulkFeatureQuantityRequest = {
    requests: '_updateFeatureQuantityRequest',
};
var _updateBulkFeatureQuantityResponse = {};
var _updateFeatureQuantityRequest = {};
var _updateFeatureQuantityResponse = {};
function resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesManagerUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/premium-features-manager-service',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/_api/premium-features-manager-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/premium-features-manager-service',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
            {
                srcPath: '/premium-features-manager-service',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/premium-features-manager-service',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/premium-features-manager',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/premium-features-manager-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/premium-features-manager-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/premium-features-manager-service',
                destPath: '',
            },
        ],
        'manage.base44.com': [
            {
                srcPath: '/_api/premium-features-manager-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesWriterUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/premium-features-writer-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Sets a feature instance's `enabled` boolean to false.
 *
 *
 * <blockquote class="warning">
 *
 * __Warning:__
 * In general, you shouldn't call Cancel Feature By Name.
 * The Dynamic Offering app automatically cancels feature instances whenever neccessary.
 * Contact the [Dynamic Offering team](https://wix.slack.com/archives/CS18R7NCF)
 * for more information.
 *
 * </blockquote>
 *
 * The instance remains disabled, even once a new billing cycle starts.
 *
 * In case there is more than one feature instance for the specified Wix
 * account or site, all instances are canceled. And the customer has no longer
 * access to the feature.
 *
 * <blockquote class="warning">
 *
 * __Warning:__
 * You must have both `PREMIUM.FEATURE_WRITER_CANCEL_FEATURE_BY_NAME` and
 * `PREMIUM.UPDATE_FEATURES` permissions to call Cancel Feature by Name.
 *
 * </blockquote>
 */
export function cancelFeatureByName(payload) {
    var _a = serializer(_cancelFeatureByNameRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelFeatureByNameResponse, {}).fromJSON;
    function __cancelFeatureByName(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'PUT',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesWriter.CancelFeatureByName',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesWriterUrl({
                protoPath: '/v1/features/{uniqueName}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelFeatureByName.fromReq = fromReq;
    __cancelFeatureByName.__isAmbassador = true;
    return __cancelFeatureByName;
}
/**
 * Creates an instance of a feature for a Wix account or site.
 *
 *
 * <blockquote class="warning">
 *
 * __Warning:__
 * In general, you shouldn't call Create Feature.
 * The Dynamic Offering app listens to all
 * [`created` events in the Subscription Manager API](https://bo.wix.com/wix-docs/rest/premium/premium-subscriptions-manager/subscription-event)
 * and automatically sets up the related feature instance.
 * Contact the [Dynamic Offering team](https://wix.slack.com/archives/CS18R7NCF)
 * for more information.
 *
 * </blockquote>
 *
 * There are no status validations for the related
 * [feature](https://bo.wix.com/wix-docs/rest/premium/feature-catalog-v2/feature-object)
 * and [product](https://bo.wix.com/wix-docs/rest/premium/premium-product-catalog-v2/products/product-object).
 * But we recommend that you only create instances for `"PUBLISHED"` features
 * that are included in a `"PUBLISHED"` product.
 *
 * You can create instances for both boolean and quota features. Boolean
 * features are always enabled until you manually cancel them by calling
 * [Cancel Feature By Name](https://bo.wix.com/wix-docs/rest/premium/premium-features-writer/cancel-feature-by-name).
 * Quota features have a limited usage quota per billing cycle. See `quotaInfo`
 * in the [Features Manager API](https://bo.wix.com/wix-docs/rest/premium/premium-features-manager/get-feature)
 * for more information. You can't create a feature instance if the type and
 * `context` don't match the feature's type and context.
 *
 * Note that the feature instance's billing cycle starts immediately after the
 * instance is created. For example, for monthly instances, the billing cycle
 * doesn't automatically start on the first day of the month.
 *
 * <blockquote class="warning">
 *
 * __Warning:__
 * You must have both `PREMIUM.FEATURE_WRITER_CREATE_FEATURE` and
 * `PREMIUM.CREATE_FEATURES` permissions to call Create Feature.
 *
 * </blockquote>
 */
export function createFeature(payload) {
    var _a = serializer(_createFeatureRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createFeatureResponse, {}).fromJSON;
    function __createFeature(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'POST',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesWriter.CreateFeature',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesWriterUrl({
                protoPath: '/v1/features',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createFeature.fromReq = fromReq;
    __createFeature.__isAmbassador = true;
    return __createFeature;
}
/**
 * Updates the feature instance's `quotaInfo` object. You can call
 * this endpoint only for quota features.
 *
 *
 * <blockquote class="warning">
 *
 * __Warning:__
 * In general, you shouldn't call Update Feature Quantity.
 * Contact the [Dynamic Offering team](https://wix.slack.com/archives/CS18R7NCF)
 * if you think that your use case requires access to this endpoint.
 *
 * </blockquote>
 *
 * Sets new usage limits for an instance of a quantity feature. You can't set
 * a `period` that isn't identical to the period that's defined in the
 * [Feature Catalog](https://bo.wix.com/wix-docs/rest/premium/feature-catalog-v2/feature-object).
 *
 * The new usage quota affects the current and future billing cycles.
 *
 * The call doesn't validate the `status` of the related
 * [feature](https://bo.wix.com/wix-docs/rest/premium/feature-catalog-v2/feature-object).
 *
 * In case there is more than one feature instance for the specified Wix
 * account or site, all instances are updated.
 *
 * UPDATE: update of the limit in this endpoint will be saved in `overrideSettings` field.
 * Actual limit for that feature would be: max(catalog limit, overrideSettings limit)
 */
export function updateFeatureQuantity(payload) {
    var _a = serializer(_updateFeatureQuantityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateFeatureQuantityResponse, {}).fromJSON;
    function __updateFeatureQuantity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'PUT',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesWriter.UpdateFeatureQuantity',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesWriterUrl({
                protoPath: '/v1/features/{uniqueName}/quantity',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateFeatureQuantity.fromReq = fromReq;
    __updateFeatureQuantity.__isAmbassador = true;
    return __updateFeatureQuantity;
}
/**
 * Updates `quotaInfo` objects for multiple feature instances. You can
 * only call this endpoint for quota features.
 *
 *
 * <blockquote class="warning">
 *
 * __Warning:__
 * In general, you shouldn't call Update Bulk Feature Quantity.
 * Contact the [Dynamic Offering team](https://wix.slack.com/archives/CS18R7NCF)
 * if you think that your use case requires access to this endpoint.
 *
 * </blockquote>
 *
 * Sets new usage limits for multiple instances of quantity features. You
 * can't set a `period` that isn't identical to the period that's defined in the
 * [Feature Catalog](https://bo.wix.com/wix-docs/rest/premium/feature-catalog-v2/feature-object).
 *
 * The new usage quotas affect the current and future billing cycles.
 *
 * The call doesn't validate the `status` of the related
 * [features](https://bo.wix.com/wix-docs/rest/premium/feature-catalog-v2/feature-object).
 *
 * In case there is more than one feature instance for any of the specified
 * Wix accounts or sites, all instances that belong to this context are
 * updated.
 */
export function updateBulkFeatureQuantity(payload) {
    var _a = serializer(_updateBulkFeatureQuantityRequest, { _updateFeatureQuantityRequest: _updateFeatureQuantityRequest }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBulkFeatureQuantityResponse, {}).fromJSON;
    function __updateBulkFeatureQuantity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'PUT',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesWriter.UpdateBulkFeatureQuantity',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesWriterUrl({
                protoPath: '/v1/crud/bulk-features/quantity',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBulkFeatureQuantity.fromReq = fromReq;
    __updateBulkFeatureQuantity.__isAmbassador = true;
    return __updateBulkFeatureQuantity;
}
/**
 * Retrieves a list of feature instances, given the provided filtering and sorting.
 *
 *
 * Both instances that the customer is still eligible to use and those that they
 * have reached the usage quota for are returned.
 *
 * <blockquote class='warning'>
 *
 * __Important__:
 *
 * The List features endpoint places a heavy workload on the servers.
 * Avoid calling it unnecessarily. Instead, you should call
 * [Is Eligible](https://bo.wix.com/wix-docs/rest/premium/premium-features-manager/is-eligible)
 * whenever possible.
 *
 * </blockquote>
 *
 * If a feature is available free of charge to users, it has a feature ID of `DEFAULT`.
 */
export function listFeatures(payload) {
    var _a = serializer(_listFeaturesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listFeaturesResponse, {
        _feature: _feature,
        _quotaInfo: _quotaInfo,
        _quotaInfoEntry: _quotaInfoEntry,
    }).fromJSON;
    function __listFeatures(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesManager.ListFeatures',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesManagerUrl({
                protoPath: '/v1/features',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listFeatures.fromReq = fromReq;
    __listFeatures.__isAmbassador = true;
    return __listFeatures;
}
/**
 * Retrieves all instances of a specific feature that are associated with the customer.
 *
 *
 * Features may be included in multiple products simultaneously,
 * thus customers may have access to more than a single instance of a specific feature.
 *
 * Both instances that the customer is still eligible to use and those that they
 * have reached the usage quota for are returned.
 *
 * > __Note__: Call [Is Eligible](https://bo.wix.com/wix-docs/rest/premium/premium-features-manager/is-eligible)
 * > to check whether a user currently has access to the specified feature.
 *
 * If a feature is available free of charge to customers, it has a feature ID of `DEFAULT`.
 */
export function getFeature(payload) {
    var _a = serializer(_getFeatureRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFeatureResponse, {
        _feature: _feature,
        _quotaInfo: _quotaInfo,
        _quotaInfoEntry: _quotaInfoEntry,
    }).fromJSON;
    function __getFeature(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesManager.GetFeature',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesManagerUrl({
                protoPath: '/v1/features/{uniqueName}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFeature.fromReq = fromReq;
    __getFeature.__isAmbassador = true;
    return __getFeature;
}
/**
 * Retrieves instances for multiple features.
 *
 *
 * Features may be included in multiple products simultaneously,
 * thus customers may have access to more than a single instance of a specific feature.
 *
 * Both instances that the customer is still eligible to use and those that they
 * have reached the usage quota for are returned.
 *
 * Use this endpoint to retrieve information about the general settings of the
 * feature’s quota, but not when checking the currently remaining quota.
 *
 * > __Note__: Call [Is Eligible](https://bo.wix.com/wix-docs/rest/premium/premium-features-manager/is-eligible)
 * > to check whether a user currently has access to the specified feature.
 *
 * If a feature is available free of charge to users, it has a feature ID of `DEFAULT`.
 */
export function getFeaturesBulk(payload) {
    var _a = serializer(_getFeaturesBulkRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFeaturesBulkResponse, {
        _feature: _feature,
        _quotaInfo: _quotaInfo,
        _quotaInfoEntry: _quotaInfoEntry,
    }).fromJSON;
    function __getFeaturesBulk(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesManager.GetFeaturesBulk',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesManagerUrl({
                protoPath: '/v1/bulk-features',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFeaturesBulk.fromReq = fromReq;
    __getFeaturesBulk.__isAmbassador = true;
    return __getFeaturesBulk;
}
/**
 * Checks whether the customer is currently allowed to use the feature.
 *
 *
 * You must specify how many times the customer intends to use the feature by
 * passing `eligibleToIncrementBy`.
 *
 * If a customer has access to multiple instances of the same feature, the
 * returned `isEligible` boolean is `true` when the request doesn't exceed the
 * combined remaining quota for all instances. In case the customer would
 * exceed the combined remaining quota, `isEligible` is returned as `false`.
 */
export function isEligible(payload) {
    var _a = serializer(_isEligibleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_isEligibleResponse, {
        _quotaInfoEntry: _quotaInfoEntry,
        _quotaViolation: _quotaViolation,
    }).fromJSON;
    function __isEligible(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesManager.IsEligible',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesManagerUrl({
                protoPath: '/v1/features/{uniqueName}/is-eligible',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __isEligible.fromReq = fromReq;
    __isEligible.__isAmbassador = true;
    return __isEligible;
}
/**
 * Checks whether the customer is currently allowed to use a list of features.
 *
 *
 * You must specify how many times the customer intends to use each feature by
 * passing `eligibleToIncrementBy`.
 *
 * If a customer has access to multiple instances of the same feature, the
 * returned `isEligible` boolean is `true` when the request doesn't exceed the
 * combined remaining quota for all instances. In case the customer would
 * exceed the combined remaining quota, `isEligible` is returned as `false`.
 */
export function bulkIsEligible(payload) {
    var _a = serializer(_bulkIsEligibleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkIsEligibleResponse, {
        _isEligibleResult: _isEligibleResult,
        _quotaInfoEntry: _quotaInfoEntry,
        _quotaViolation: _quotaViolation,
    }).fromJSON;
    function __bulkIsEligible(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'POST',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesManager.BulkIsEligible',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesManagerUrl({
                protoPath: '/v1/features/is-eligible',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkIsEligible.fromReq = fromReq;
    __bulkIsEligible.__isAmbassador = true;
    return __bulkIsEligible;
}
/**
 * Logs that a user has used the feature instance.
 *
 *
 * You must specify how many times the feature instance has been used via the
 * `incrementBy` parameter.
 *
 * > __Note__: This endpoint doesn’t check whether a user is eligible to use
 * > the feature. To do so call
 * > [Is Eligible](https://bo.wix.com/wix-docs/rest/premium/premium-features-manager/is-eligible)
 * > before reporting the quota.
 *
 * If a customer has access to multiple instances of the same feature, the
 * usage isn't reported for an individual instance. Instead, it's logged in a
 * combined manner for all instances.
 *
 * Triggers an `updated`
 * [Feature Event](https://bo.wix.com/wix-docs/rest/premium/premium-features-manager/feature-event).
 */
export function reportQuotaUsage(payload) {
    var _a = serializer(_reportQuotaUsageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reportQuotaUsageResponse, {}).fromJSON;
    function __reportQuotaUsage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.features_manager.v1.feature',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.featuresmanager.api.v1.FeaturesManager.ReportQuotaUsage',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressPremiumFeaturesmanagerApiV1FeaturesManagerUrl({
                protoPath: '/v1/features/{uniqueName}/report-quota-usage',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reportQuotaUsage.fromReq = fromReq;
    __reportQuotaUsage.__isAmbassador = true;
    return __reportQuotaUsage;
}
//# sourceMappingURL=http.impl.js.map